module.exports = __webpack_public_path__ + "img/Twitter-Original.ba1f7c2.svg";